import TagNarrative from './TagNarrative'

export default TagNarrative
